import { BusinessUnit } from '@shared/types/business-unit/BusinessUnit';
import { BusinessUnit as EntityBusinessUnit } from '@/types/entity/business-unit';
import { mapAddress } from './map-address';
import { mapStore } from './map-store';
import { mapAssociate } from './map-associate';

// EWM-345 — When extending this mapper, every field the FE consumes must
// appear in BOTH the destructure AND the returned object. Missing fields
// silently become `undefined` on `selectedBusinessUnit`; the
// credit-status redirect was broken for an entire release because
// `creditStatus` / `creditLimit` were on the canonical type + BFF
// mapper but not threaded through this FE mapper. The strict-rule
// route guard depends on these — keep them in sync.
export const mapBusinessUnit = ({
  businessUnitId,
  key,
  name,
  contactEmail,
  addresses,
  stores,
  topLevelUnit,
  parentUnit,
  associates,
  abn,
  paymentTerms,
  billingEmail,
  dealerTier,
  createdAt,
  fisThreshold,
  creditLimit,
  creditStatus,
  payOnAccountTermsApproved,
  backOrdersAllowed,
  pickDayFlags,
  primaryAssociateId,
  salesRep,
}: BusinessUnit): EntityBusinessUnit => {
  return {
    id: businessUnitId as string,
    name: name ?? '',
    key: key ?? '',
    email: contactEmail ?? '',
    addresses: (addresses ?? []).map(mapAddress),
    stores: (stores ?? []).map(mapStore),
    topLevelUnit: topLevelUnit && topLevelUnit.key !== key ? mapBusinessUnit(topLevelUnit) : undefined,
    parentUnit: parentUnit && parentUnit.key !== key ? mapBusinessUnit(parentUnit) : undefined,
    associates: (associates ?? []).map(mapAssociate),
    abn,
    paymentTerms,
    billingEmail,
    dealerTier,
    createdAt,
    fisThreshold,
    creditLimit,
    creditStatus,
    payOnAccountTermsApproved,
    backOrdersAllowed,
    pickDayFlags,
    primaryAssociateId,
    salesRep,
  };
};
